import {useEffect, useState, useRef} from "react";
/* Routing */
import { useParams, useNavigate } from "react-router-dom";
/* Contexts */
import useDeceased from "../../../hooks/useDeceased";
import Header from "../../../components/common/Header";
import {Link} from "react-router-dom";
import {getDeceasedCondolenceList, printCondolences, uploadPfMessage} from "../../../api/pro/condolenceReq";
import useAuth from "../../../hooks/useAuth";
import {getDeceasedInfos} from "../../../api/pro/deceasedReq";
import jwt_decode from "jwt-decode";
import FormCondolenceMessage from "../../../forms/deceased/condolences/FormCondolenceMessage";
import Missing from "../../Missing";
import {checkRequiredFields, getErrorListFromValidation, removeErrorList, capitalize, upperCaseName} from "../../../helper/tools";
import Icon from "../../../components/common/Icon";
import condolenceSource from "../../../img/v2_i_condoleances.png";


export default function Condolences() {
    const [ condolenceList, setCondolenceList ] = useState([]);
    const { id } = useParams();
    const [ condolence, setCondolence ] = useState();
    const { deceasedInfos, setDeceasedInfos } = useDeceased();
    const [ showModal, setShowModal ] = useState(false);
    const { auth } = useAuth();
    const navigate = useNavigate();
    const pfMessageRef = useRef();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken.agency;
    let pfCondolenceMessages;
    let pfCondolenceList = [];
    const BASE_URL = process.env.REACT_APP_OEF_URL

    if (condolenceList.length > 0) {
        pfCondolenceMessages = condolenceList?.find(condolence => condolence?.agency === agencyId);
        pfCondolenceList = condolenceList?.filter(condolence => condolence?.inputOrg === 1);
    }
    const handleClickCondolenceModal = (condolence, e) => {
        e.preventDefault();
        setShowModal(true)
        setCondolence(condolence)
    };

    const getCondolenceLegend = (condolence) => {
        if (!condolence) return '';
        
        const formattedDate = condolence?.createdAt 
            ? new Date(condolence.createdAt).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ' - ' + new Date(condolence.createdAt).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
            : '';
        
        if (condolence?.inputOrg === 1) {
            // Pas de civilité pour les messages pompes funèbres
            return `Message de ${condolence?.firstName || ''} ${condolence?.lastName || ''} du ${formattedDate}`.trim();
        } else {
            // Affichage avec civilité pour les messages des proches
            const civility = condolence?.civility ? `${condolence.civility} ` : '';
            return `Message de ${civility}${condolence?.firstName || ''} ${condolence?.lastName || ''} du ${formattedDate}`.trim();
        }
    };

    const apiDeceasedInfos = async () => {
        const response = await getDeceasedInfos(token, id)
        setDeceasedInfos(response)
    }

    const apiCondolenceList = async () => {
        const response = await getDeceasedCondolenceList(token, id)
        setCondolenceList(response)
    };

    useEffect(() => {
        apiCondolenceList()
    }, [ id ]);

    useEffect(() => {
        apiDeceasedInfos()
    }, [ id ]);

    const handleSubmitPFMessage = async (e,ref, messageId) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: messageId ? messageId : 0,
            deceasedId: id,
            agencyId: agencyId,
            message: ref,
            web: 0,
            print: 0,
        }
        await uploadPfMessage(body, token)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    apiCondolenceList()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handlePrintCond = () => {
        if (id) {
            printCondolences(token, id)
                .then(response => {
                    if (response instanceof Blob && response.type === 'text/html') {
                        response.text().then(downloadUrl => {
                            const pdfLink = document.createElement('a');
                            pdfLink.href = downloadUrl;
                            pdfLink.target = '_blank';
                            pdfLink.setAttribute('download', `condoleances_${deceasedInfos?.lastName}_${deceasedInfos?.firstName}.pdf`);
                            document.body.appendChild(pdfLink);
                            pdfLink.click();
                            document.body.removeChild(pdfLink);
                        })
                    }
                })
        }
    }

    return (
        <main>
            { deceasedInfos?.error &&
                <Missing />
            }
            { !deceasedInfos?.error &&
            <>
            <Header
                location="Espace de modération des messages aux proches de "
                locationComp={`
                    ${ deceasedInfos?.lastName } 
                    ${ deceasedInfos?.firstName }
                `}
                parent="Défunt"
                slug={`/defunt/${deceasedInfos?.id}`}
            />
                <div className="double-fieldset">
                    <div className="condoleances">
                        { showModal &&
                            <div className="modal condolence-modal">
                                <div>
                                    <FormCondolenceMessage
                                        apiDeceasedInfos={apiDeceasedInfos}
                                        setShowModal={setShowModal}
                                        apiCondolenceList={apiCondolenceList}
                                        data={condolence}
                                        legend={getCondolenceLegend(condolence)}
                                        isPfOrg={condolence?.inputOrg === 1}
                                    />
                                </div>
                            </div>
                        }
                        <div className="content-container column">
                            <Icon span="Modération des condoléances" source={condolenceSource}/>
                            <fieldset className="from">
                                <legend>Condoléances</legend>
                                <div className="from-name">
                                    { condolenceList?.filter(condolence => condolence?.new)?.map(condolenceNew => (
                                        <Link key={condolenceNew.id} className="moderate" onClick={(e) => handleClickCondolenceModal(condolenceNew, e)}>
                                            <span>{capitalize(condolenceNew?.firstName)} {upperCaseName(condolenceNew.lastName)}</span>
                                            <span><i className="fa fa-pen-to-square"/></span>
                                        </Link>
                                    ))}
                                    { condolenceList?.filter(condolence => (!condolence?.moderated && !condolence?.new))?.map(condolence => (
                                        <Link key={condolence.id} className="rejected" onClick={(e) => handleClickCondolenceModal(condolence, e)}>
                                            <span>{capitalize(condolence?.firstName)} {upperCaseName(condolence.lastName)}</span>
                                            <span><i className="fa fa-pen-to-square"/></span>
                                        </Link>
                                    ))}
                                    { condolenceList?.filter(condolence => condolence?.moderated && !condolence?.new)?.map(condolence => (
                                        <Link key={condolence.id} className="accepted" onClick={(e) => handleClickCondolenceModal(condolence, e)}>
                                            <span>{capitalize(condolence?.firstName)} {upperCaseName(condolence.lastName)}</span>
                                            <span><i className="fa fa-pen-to-square"/></span>
                                        </Link>
                                    ))}
                                    { condolenceList.length < 1 &&
                                        <span className="accepted">Aucun message de condoléances pour ce défunt.</span>
                                    }
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="condoleances-actions">
                        <ul>
                            <li><span className="moderate"></span>Message à modérer</li>
                            <li><span className="accepted"></span>Message accepté</li>
                            <li><span className="rejected"></span>Message refusé</li>
                        </ul>
                        <div className="detail-box">
                            <legend>Liste d'impression</legend>
                            <ul>
                                { condolenceList?.filter(condolence => condolence?.print && condolence?.moderated && !condolence?.new).map(condolence => (
                                    <li key={condolence.id}>{capitalize(condolence?.firstName)} {upperCaseName(condolence?.lastName)}</li>
                                ))}
                            </ul>
                            <button className="green-button"  onClick={handlePrintCond}><i className="fa fa-print"/><span>Imprimer</span></button>
                        </div>
                        <div className="detail-box">
                            <legend>Messages publiés sur Internet</legend>
                            <ul>
                                { condolenceList?.filter(condolence => condolence?.web).map(condolence => (
                                    <li key={condolence.id}>{capitalize(condolence?.firstName)} {upperCaseName(condolence?.lastName)}</li>
                                ))}
                            </ul>
                            {deceasedInfos?.isListed &&
                                <button className="green-button"><a href={`${BASE_URL}/condoleances/${deceasedInfos?.id}-${deceasedInfos?.firstName}-${deceasedInfos?.lastName}/`} target="_blank"><i className="fa fa-eye"/>Voir</a></button>
                            }
                        </div>
                    </div>
                </div>
                <div className="buttons-container back bottom-centered">
                    <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                </div>
            </>
            }
        </main>
    )
}
